import { render, staticRenderFns } from "./DocumentUrgency.vue?vue&type=template&id=54859a0f&scoped=true"
import script from "./DocumentUrgency.vue?vue&type=script&lang=js"
export * from "./DocumentUrgency.vue?vue&type=script&lang=js"
import style0 from "./DocumentUrgency.vue?vue&type=style&index=0&id=54859a0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54859a0f",
  null
  
)

export default component.exports